export const ENV = process.env.REACT_APP_ENV || 'development';
export const APP_API_URL = process.env.REACT_APP_API_URL;
export const REACT_APP_BASE_URL = process.env.REACT_APP_BASE_URL || "https://secure.symmatics.com";
export const PAYMENT_GATEWAY_SDK = process.env.REACT_APP_PAYMENT_GATEWAY_SDK || "https://www.payhere.lk/lib/payhere.js";
export const PAYMENT_GATEWAY_MERCHANT_ID = process.env.REACT_APP_PAYMENT_GATEWAY_MERCHANT_ID || "";
export const PAGE_LIMIT = 10;